import { styleConfig } from "@chakra-ui/theme-tools";
var label = styleConfig({
  baseStyle: {
    fontSize: "sm",
    color: "gray.700",
    marginRight: "3",
    marginBottom: "1",
    fontWeight: "bold",
    transition: "all 0.2s",
    opacity: 1,
    _disabled: {
      opacity: 0.4
    }
  }
});
export default label;